import {cssTheme} from '@yandex-delivery/blocks';
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const desktopClasses = {
  gap: css`
    margin-inline-end: ${spacing(4.5)};
  `,
  label: css`
    cursor: pointer;
    &:hover, &:active {
      color: ${cssTheme.colors.deliveryGrey[200]};
    }
  `
}
